import {
  createRouteTemplate,
  CreateTemplateRoute,
  deleteRouteTemplate,
  getRouteTemplate,
  getRouteTemplates,
  RouteTemplateFilterData,
  updateRouteTemplate,
  UpdateRouteTemplate,
} from '@/features/templates'
import { queryOptions, useMutation } from '@tanstack/react-query'

export const templatesQueries = {
  all: () => ['templates'],
  lists: () => [...templatesQueries.all(), 'list'],
  list: (filter: RouteTemplateFilterData = { userOnly: true }) =>
    queryOptions({
      queryKey: [templatesQueries.lists(), filter],
      queryFn: () => getRouteTemplates(filter),
    }),
  details: () => [...templatesQueries.all(), 'detail'],
  detail: (templateId: number) =>
    queryOptions({
      queryKey: [...templatesQueries.details(), templateId],
      queryFn: () => getRouteTemplate(templateId),
    }),
}

export const useCreateRouteTemplate = () =>
  useMutation({
    mutationFn: ({ template, code }: { template: CreateTemplateRoute; code: string }) =>
      createRouteTemplate(template, code),
  })

export const useUpdateRouteTemplate = (id: number) =>
  useMutation({
    mutationFn: ({ template, code }: UpdateRouteTemplate) => updateRouteTemplate(id, template, code),
  })

export const useDeleteRouteTemplate = (id: number) =>
  useMutation({
    mutationFn: () => deleteRouteTemplate(id),
  })
